import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {ThresholdDictionary} from '../../../../shared/interface/threshold-dictionary';

@Component({
  selector: 'app-threshold-group-view',
  templateUrl: './threshold-group-view.component.html',
  styleUrls: ['./threshold-group-view.component.scss']
})
export class ThresholdGroupViewComponent implements OnInit {
  @Input() thresholdDictionary: ThresholdDictionary;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  modify(): void {
    this.modifyClicked.emit();
  }

}
